import {
  IStrapiGlobalText,
  IStrapiFooterMenu,
  IStrapiSocialButton,
  IStrapiLegalButton,
  IProviderMenu
} from '@sondermind/third-party/strapi';

export const PUBLIC_FOOTER_TABS = {
  state: 'state',
  insurance: 'insurance',
  specialty: 'specialty',
  onlineTherapy: 'onlineTherapy'
} as const;

export type TabKey = keyof typeof PUBLIC_FOOTER_TABS;

export type IFooterState = {
  id: string;
  abbreviation: string;
  name: string;
  href: string;
};

export type PublicFooterViewModel = {
  activeTab: TabKey;
  openAccordionId: string | number | null;
  states: IFooterState[];
  insurances: IProviderMenu[];
  specialties: IProviderMenu[];
  onlineTherapyInStates: IFooterState[];
  footerMenus: IStrapiFooterMenu[];
  socialButtons: IStrapiSocialButton[];
  legalButtons: IStrapiLegalButton[];
  globalText: IStrapiGlobalText | null;
};
